// @flow

import * as Immutable      from 'immutable';
import invariant           from 'invariant';
import createAction        from 'redux-actions/lib/createAction';
import type { CookieType } from '../../config/cookiesConfig';
import type { MD5Hash }    from '../../domain/types';


// -----------------------------------------------------------------------------------------------------------------
// Actions
// -----------------------------------------------------------------------------------------------------------------

// updateCookieSettings
// --------------------

// Types…

type CookieTypeSettingKey = 'enabled';

export type CookieTypeSetting = {
  enabled: boolean,
  configHash: MD5Hash,
};

export type UpdateCookieSettingsPayload = {|
  cookieSettings: Immutable.Map<CookieType, CookieTypeSetting>
|};

export type UpdateCookieSettingsActionArgs = {|
  ...UpdateCookieSettingsPayload,
|};

export type UpdateCookieSettingsAction = {|
  payload: UpdateCookieSettingsPayload,
|}

export type UpdateCookieSettingsActionFactory = (UpdateCookieSettingsActionArgs) => UpdateCookieSettingsAction;

// Action…

const updateUserCookieSettings: UpdateCookieSettingsActionFactory = createAction(
  'COOKIE_SETTINGS:USER_SETTINGS:UPDATE',
  ({cookieSettings}) => {
    Immutable.Map(cookieSettings).forEach((cookieTypeSetting: CookieTypeSetting, cookieType: CookieType) => {
      invariant(
        'boolean' === typeof cookieTypeSetting.enabled,
        `Expected 'enabled' property of '${cookieType}' settings to be boolean.`,
      );
      invariant(
        'string' === typeof cookieTypeSetting.configHash,
        `Expected 'configHash' property of '${cookieType}' settings to be a hash string.`,
      );
    });

    return {cookieSettings};
  },
);


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default updateUserCookieSettings;



// WEBPACK FOOTER //
// ./src/actions/cookieSettings/updateUserCookieSettings.js